<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import Widget from './widget'


/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '360MDR Real Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data() {
    return {
      dashboard: {
        "widgets": [
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-COLBOG01",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-COLBOG01",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-COLBOG02",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-COLBOG02",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-FUG-01",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-FUG-01",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-FUG-02",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-FUG-02",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-USAMFD01",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-USAMFD01",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-USAMFD02",
            "source": "/pan/ngfw/agg/uptime/day?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-USAMFD02",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
        ]
      },
      // jsonDef: '@src/router/views/pages/dashboard/data/'+name,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      startEpoch: 0,
      endEpoch: 99999999999
    }
  },
  computed: {

  },
  mounted () {

    // console.log(this.jsonDef)
  },
  methods: {

  },
}
</script>

<template>
  <Layout>
    <div class="container" style="max-width: 1420px !important;">
      <div class="row page-title align-items-center">

      </div>
      <div class="row">
        <template v-for="(widget, index) in dashboard.widgets">
          <!-- <div :class="widget.cols">
            <span><h5>{{ widget.name }}</h5></span>
            <b-card no-body class="text-center" style="line-height:300px">
              {{ widget.component }}
            </b-card>
          </div> -->
          <Widget v-bind:key="index"
                  :title="widget.name"
                  :component="widget.component"
                  :source="widget.source"
                  :series="widget.series"
                  :cols="widget.cols"
                  :trend="widget.trend"
                  :wclass="widget.class"
                  :type="widget.type"
                  :labels="widget.labels"
                  :cardStyle="widget.cardStyle"
                  :categories="widget.categories"
                  :colors="widget.colors"
                  :colorsByLabel="widget.colorsByLabel"
                  :range="widget.range"
                  :start="startEpoch"
                  :end="endEpoch"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>
